<template>
  <div class="p-3 raised rounded">
    <div class="column-title border-bottom mb-2">Items Needed Before Approval</div>
    <ul>
      <li
        v-for="(item, idx) in this.neededDocs"
        v-bind:key="idx"
      >
        {{item}}
      </li>
    </ul>
  </div>
</template>

<script>
import SimpleTitle from '@/components/utils/SimpleTitle';


export default {
  name: 'NeededForApproval',
  components: {
    SimpleTitle,
  },
  props: {
    neededDocs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      missingDocs: ['Borrower Application', 'Driver\'s License'],
    };
  },
};
</script>
<style scoped>
.column-title {
  font-weight: bold;
  font-size: 18px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/entities/NeededForApproval.vue